<template>
    <div class="p-3 row">
        <input-select class="col-12" label="Profissional/Equipe" v-model="form.pessoaId" :options="pessoas"/>
        <input-select class="col-12 col-md-6" label="Ano" v-model="form.ano" :options="anos"/>
        <input-select class="col-12 col-md-6" label="Mês" :disabled="!this.form.ano" v-model="form.mes" :options="mesesFiltrados"/>

        <div class="col-12 mb-2">
            <upload 
                    id="contrato"
                    tituloArquivo="Arrastar Arquivo" 
                    selecioneArquivo="Selecionar Arquivo" 
                    type=".*"

                    :arquivo-download="form.conteudoBase64"
                    :arquivo-download-nome="form.nomeArquivoAWS"

                    @upload="(file, nomeArquivo)=> {                   
                        form.nomeArquivoAWS = nomeArquivo;
                        form.conteudoBase64 = file;
                        this.$forceUpdate();
                    }" />
        </div>

        <div class="col-12">
            <b-button variant="success" v-if="permissao.c && controles" @click="salvar">
                <i class="fa-solid fa-check mr-2"></i>
                Salvar
            </b-button>
        </div>
        <div class="col-12 mt-3">
            <h6>Lista de arquivos</h6>
            <b-table head-variant="dark" hover :fields="colunas" :items="itens">
                <template  #cell(actions)="data">
                    <div class="d-inline-flex">
                        <b-button variant="flat-primary" class="mr-2" @click="download(data.item.id)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                        <b-button variant="flat-danger" v-if="controles && permissao.d" class="mr-2" @click="excluir(data.item.id)"><i class="fas fa-trash"></i></b-button>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import InputSelect from '@/components/inputs/InputSelect';
import Upload from '@/components/upload/Upload';

import {FormMixin} from '@/common/mixins/FormMixin';
import {AlertasMixin} from '@/common/mixins/AlertasMixin';
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import ProjetoService from '@/common/services/projeto/projeto.service';

import helpers from '@/common/utils/helpers';

export default {
    name: "FormularioHH",
    mixins: [FormMixin, AlertasMixin],
    components: {
        Upload,
        InputSelect
    },
    props : {
        equipeId : {
            required: true
        },
        nomeIdProjeto : {
            type : String,
            required : true
        },
        projetoId : {
            type : String,
            required : true
        },
        projeto : {
            required : true
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    data : () => ({
        form : {
            nomeArquivoAWS : '',
            extensao : '',
            conteudoBase64 : '',
            data : null,
            ano : null,
            mes : null,
            pessoaId : null
        },
        colunas : [],
        itens : [],

        anos : [],
        meses : [],
        pessoas : [],
    }),
    methods: {
        limpar: function() {
            this.form = {
                nomeArquivoAWS : '',
                extensao : '',
                conteudoBase64 : '',
                data : null,
                versao : null,
                ano : null,
                mes : null,
                pessoaId : null
            };
        },
        salvar: function() {
            if(!this.validateState())
                return;

            if(!this.form.conteudoBase64){
                this.alertaErro('Informe o arquivo para salvar');
                return;
            }

            this.confirmar("Deseja realmente salvar o arquivo?").then(confirmado => {
                if(!confirmado)
                    return;
                    
                this.$store.dispatch(START_LOADING);
                let form = this.form;
                form.recursoHumanoId = this.equipeId;
                form.data = form.ano ? `${form.ano}-${form.mes}-01`: null
                ProjetoService.salvarComprovanteHH(form).then(() => {
                    this.alertaSucesso("Arquivo salvo com sucesso!");
                    this.buscarArquivos();
                }).catch(err => {
                    if((err.response ? err.response.status : 0) == 400){
                        this.alertaErro(`Erro ao salvar arquivo: ${err.data.errors}`);
                    }else{
                        this.alertaErro(`Erro ao salvar arquivo`);
                    }
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            })
        },

        excluir: function(id) {
            this.confirmar("Deseja realmente excluir o arquivo?").then(confirmado => {
                if(!confirmado)
                    return;
                    
                this.$store.dispatch(START_LOADING);
                ProjetoService.deletarComprovanteHH(id).then(() => {
                    this.alertaSucesso("Arquivo excluido com sucesso!");
                    this.buscarArquivos();
                }).catch(err => {
                    if((err.response ? err.response.status : 0) == 400){
                        this.alertaErro(`Erro ao excluir arquivo: ${err.data.errors}`);
                    }else{
                        this.alertaErro(`Erro ao excluir arquivo`);
                    }
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            })
        },
        buscarArquivos: function(equipeId) {
            this.$store.dispatch(START_LOADING);
            ProjetoService.listarComprovanteHH(!this.equipeId ? equipeId : this.equipeId).then(res => {
                this.itens = res.data.data;
            }).catch(() => {   
                this.alertaErro(`Erro ao buscar arquivos`);
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        download : function(id){
            this.$store.dispatch(START_LOADING);

            ProjetoService.downloadComprovanteHH(id)
            .then(response => {
                helpers.baixarArquivo(response.data, response.headers);
                this.alertaSucesso("Download do Arquivo Concluido!");               
            }).catch(err => {
                console.log(err);
                this.alertaErro("Erro ao fazer Download do Arquivo");
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        montar(equipeId){
            this.buscarPessoas();
            this.montarDatas();
            this.buscarArquivos(equipeId);
            this.colunas = [
                { key: "nomeArquivoAWS", label:"Nome do arquivo"},
                { key: "pessoaId", label:"Equipe/Pessoa", formatter : (v) => {
                    let pessoa = this.pessoas.find(el => el.value == v);
                    return pessoa.text
                }},
                { key: "data", label:"Data",
                    formatter: (value) => {
                        if(!value)
                            return "Todo período";
                        return helpers.formatarDataBr(value)
                    }
                },
                { key: "actions", label:"Ações"},
            ]

        },

        buscarPessoas : function(){
            ProjetoService.listarRH(this.projetoId, this.nomeIdProjeto).then(res => {
                this.pessoas = [
                    {value : null, text : "Toda a equipe"},    
                    ...(res.data.data ? res.data.data.equipe.alocacaoHorasIndividuais.map(el => {
                        return {
                            value : el.pessoa.id,
                            text : el.pessoa.nome
                        }
                    }) : [])
                ];
            })
        },
        montarDatas: function(){
            this.meses = [
                {value : null, text : "Todos meses"},    
                ...helpers.retornarMeses()
            ];
            
            let anoInicio = parseInt(helpers.formatarData(this.projeto.dataInicio, 'YYYY'));
            let mesInicio = parseInt(helpers.formatarData(this.projeto.dataInicio, 'MM'));
            let duracao = this.projeto.duracao + mesInicio;
            
            this.anos.push({value : null, text : "Todos anos"})
            
            for (let i = 0; i < duracao / 12; i++) {
                
                this.anos.push({value : anoInicio + i , text : anoInicio + i })
            }
        }
    },
    computed: {
        controles :function(){
            return this.projetoEditavel;
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosPdRecursoHumano');
        },
        mesesFiltrados : function(){
            
            return this.form.ano ? this.meses.filter(el => el.value != null) : this.meses
        }
    },
    watch : {
        "form.ano" : function(){
            if(this.form.ano){
                if(!this.form.mes)
                    this.form.mes = 1
            }else{
                this.form.mes = null;
            }
        }
    }
}
</script>
<style lang="">
    
</style>